import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify"; // 'vuetify'の変数名変えると動かなくなる
import VueCompositionApi from './plugins/composition-api';
import Glsl from './plugins/vue-glsl' 

Vue.config.productionTip = false;

new Vue({
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  VueCompositionApi,
  Glsl,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
